import useSWR from 'swr'
import { contentful } from './api'
import { IContentfulRichText } from './contentful.types'
import { CONTENTFUL_DOCUMENT_SLUGS } from './slugs/document'

const PREFIX = '@contentful/getDocument'

type IDocument = IContentfulRichText

export type ContentfulDocumentSlug = (typeof CONTENTFUL_DOCUMENT_SLUGS)[number]

async function getDocument(slug: string): Promise<IDocument> {
  const res = await contentful.getDocumentBySlug({ slug: slug.replace(`${PREFIX}/`, '') })

  return res.pageDocumentCollection?.items[0]?.content as IDocument
}

export function useDocument(slug: ContentfulDocumentSlug) {
  return useSWR<IDocument>(`${PREFIX}/${slug}`, getDocument)
}
